import { createContext } from "react";

const ReduceContext = createContext();

export default ReduceContext;
